'use strict';

/**
 * List of objects in a specific location
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ListLayout = require('modules/collection/views/layout/list');
var ObjectDetailHeaderView = require('./object-detail-header');
var StoragesEmptyView = require('../partials/storages-empty');

var ObjectDetailListLayout = ListLayout.extend({
    getHeaderViewClass: function () {
        return ObjectDetailHeaderView;
    },

    getEmptyViewClass: function () {
        return StoragesEmptyView;
    },
});

module.exports = ObjectDetailListLayout;